import React from 'react';
import CreatableSelect from 'react-select/creatable';
import { useDispatch } from "react-redux";
import { setCertificateLabel } from "../actions/searchAction";

//Ref: https://react-select.com/props

const options = [
  { value: "0", label: 'Automatic' },
  { value: "1", label: 'School' },
  { value: "2", label: 'HigherEducation' },
  { value: "3", label: 'Work' },
  { value: "4", label: 'Covid' },
]

const styles = {
  control: (css) => ({ ...css, width: "150px" })
}

export const CertTypeCombobox = (props) => {
  const dispatch = useDispatch();

  return (
    <div>
      <CreatableSelect
        styles={styles}
        options={options}
        defaultValue={{ label: props.selectedCertLabel }}
        onChange={(newValue, actionMeta) => dispatch(setCertificateLabel(newValue.label))} />
    </div>
  );
}